import { defineComponent as _defineComponent } from 'vue'
import VPreLoader from "@/components/vPreLoader.vue";
import {computed, onUnmounted, ref, watch} from "vue";
import VBanner from "@/components/vBanner.vue";
import {useTranslations} from "@/hooks/useTranslations";

type vLabelPreviewImageProps = {
  isLoading: boolean;
  loadingErrorMessage: string;
  shouldDisplayLabel: boolean;
  labelPreviewData: {
    isBase64: boolean;
    resource: Blob;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LabelPreviewImage',
  props: {
    isLoading: { type: Boolean, default: false },
    loadingErrorMessage: { default: "" },
    shouldDisplayLabel: { type: Boolean },
    labelPreviewData: null
  },
  setup(__props: any) {

const props = __props as { isLoading: boolean, loadingErrorMessage: string, shouldDisplayLabel: boolean, labelPreviewData: {
    isBase64: boolean;
    resource: Blob;
  } };

const translations = useTranslations();



const imageUrl = ref("");
const errorMessageText = computed(() => {
  const translation = translations.value.get(props.loadingErrorMessage);

  if (translation === '---') {
    return props.loadingErrorMessage;
  }

  return translation;
});

const zoom = ref(1);
const offsetX = ref(0);
const offsetY = ref(0);
const isPanning = ref(false);
const startX = ref(0);
const startY = ref(0);

watch(props, (newData) => {
  try {
    URL.revokeObjectURL(imageUrl.value);
  }

  catch (ex) {
    console.debug("Failed to revoke url: ", ex);
  }

  try {
    imageUrl.value = URL.createObjectURL(newData.labelPreviewData.resource);
  }

  catch (ex) {
    console.debug("Failed to create url: ", ex);
  }
});

onUnmounted(() => {
  URL.revokeObjectURL(imageUrl.value);
});

const imageStyle = computed(() => ({
  transform: `translate(${offsetX.value}px, ${offsetY.value}px) scale(${zoom.value})`,
  cursor: zoom.value > 1 ? "grab" : "default",
  transition: isPanning.value ? "none" : "transform 0.15s ease"
}));

function zoomIn() {
  zoom.value = Math.min(zoom.value + 0.1, 4);
}

function zoomOut() {
  zoom.value = Math.max(zoom.value - 0.1, 1);
  if (zoom.value === 1) {
    offsetX.value = 0;
    offsetY.value = 0;
  }
}

function onScrollZoom(event: WheelEvent) {
  const direction = event.deltaY > 0 ? -0.1 : 0.1;
  const newZoom = zoom.value + direction;

  if (newZoom < 1 || newZoom > 4) return;

  zoom.value = newZoom;
}

function startPan(event: MouseEvent) {
  if (zoom.value <= 1) return;

  isPanning.value = true;
  startX.value = event.clientX - offsetX.value;
  startY.value = event.clientY - offsetY.value;
}

function pan(event: MouseEvent) {
  if (!isPanning.value) return;

  offsetX.value = event.clientX - startX.value;
  offsetY.value = event.clientY - startY.value;
}

function endPan() {
  isPanning.value = false;
}


return { __sfc: true,translations, props, imageUrl, errorMessageText, zoom, offsetX, offsetY, isPanning, startX, startY, imageStyle, zoomIn, zoomOut, onScrollZoom, startPan, pan, endPan, VPreLoader, VBanner }
}

})